var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"more"}},[_vm._v(" 等待更新 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }